import {VictorTenantType} from '@volkswagen-onehub-cms/cms-victor-bff';
import {VictorTenantType as JavaVictorTenantType} from '../../generated/core';

export function convertVictorTenantType(
    victorTenantType: JavaVictorTenantType | undefined
): VictorTenantType {
    return victorTenantType === 'COMMERCIAL' ? 'commercial' : 'private';
}
